/**
 * Removes rate paid by producer
 * (backend adds the rate for producers to the sum, but what frontend needs to display is only the beneficiary rate).
 */
export const formatRates = (value: number) => {
    if (value === 8) return 6;
    if (value === 4) return 3;
    return value;
};
